import { AdImageType } from "./AdImage";

const DEFAULT_RATIO = 1;

enum RatioClassNames {
  LANDSCAPE = "aspect-w-4 aspect-h-3",
  PORTRAIT = "aspect-w-3 aspect-h-4",
  SQUARE = "aspect-w-1 aspect-h-1",
}

type AspectRatioOptions = {
  defaultRatio?: number;
};

export default function getAspectRatio(
  { aspectRatio, height, width }: AdImageType,
  options?: AspectRatioOptions
): string {
  const { defaultRatio = DEFAULT_RATIO } = options ?? {};
  const ratio: number =
    computeAspectRatio(aspectRatio, height, width) ?? defaultRatio;

  if (ratio >= 1.29) {
    return RatioClassNames.LANDSCAPE;
  } else if (ratio <= 0.76) {
    return RatioClassNames.PORTRAIT;
  } else {
    return RatioClassNames.SQUARE;
  }
}

function computeAspectRatio(
  ratio?: number,
  height?: number,
  width?: number
): number | null {
  if (ratio && ratio > 0) {
    return ratio;
  } else if (width && height && width > 0 && height > 0) {
    return width / height;
  } else {
    return null;
  }
}
